import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

const AREAS = [
  { name: "Bole", tagline: "Luxury Living", img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&w=640&q=70" },
  { name: "Kazanchis", tagline: "Prime Location", img: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?crop=entropy&cs=srgb&fm=jpg&w=640&q=70" },
  { name: "CMC", tagline: "Family Friendly", img: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&w=640&q=70" },
  { name: "Piassa", tagline: "Great Connectivity", img: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?crop=entropy&cs=srgb&fm=jpg&w=640&q=70" },
  { name: "Summit", tagline: "Modern Suburb", img: "https://images.unsplash.com/photo-1494526585095-c41746248156?crop=entropy&cs=srgb&fm=jpg&w=640&q=70" },
  { name: "Sarbet", tagline: "Central & Vibrant", img: "https://images.unsplash.com/photo-1460317442991-0ec209397118?crop=entropy&cs=srgb&fm=jpg&w=640&q=70" },
  { name: "Bishoftu", tagline: "Lakeside Retreat", img: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?crop=entropy&cs=srgb&fm=jpg&w=640&q=70" },
  { name: "Hawassa", tagline: "Resort City", img: "https://images.unsplash.com/photo-1505761671935-60b3a7427bad?crop=entropy&cs=srgb&fm=jpg&w=640&q=70" },
];

export const PopularAreas = () => {
  const { t: pt } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="bg-background py-12 sm:py-16" data-testid="popular-areas-section">
      <div className="abay-container">
        <div className="flex items-end justify-between gap-4">
          <div>
            <h2 className="text-2xl font-bold tracking-tight text-foreground sm:text-3xl">{pt("popular.title")}</h2>
            <p className="mt-2 text-sm text-muted-foreground sm:text-base">Explore the most sought-after neighborhoods across Ethiopia.</p>
          </div>
          <button
            type="button"
            onClick={() => navigate("/map-search")}
            data-testid="popular-areas-view-all"
            className="flex shrink-0 items-center gap-1 text-sm font-semibold text-[#1E3A8A] transition-colors duration-200 hover:text-[#172D6B] dark:text-[#7AA0FF]"
          >
            {pt("common.viewAll")} <ArrowRight className="h-4 w-4" />
          </button>
        </div>

        <div className="mt-6 grid grid-flow-col auto-cols-[72%] gap-4 overflow-x-auto pb-2 thin-scroll snap-x snap-mandatory sm:auto-cols-[44%] lg:auto-cols-[23%]">
          {AREAS.map((a, i) => (
            <motion.button
              key={a.name}
              type="button"
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.35, delay: Math.min(i, 6) * 0.04 }}
              onClick={() => navigate(`/map-search?q=${encodeURIComponent(a.name)}`)}
              data-testid={`popular-area-${a.name.toLowerCase()}`}
              className="tap-press group relative aspect-[4/3] snap-start overflow-hidden rounded-2xl text-left shadow-[var(--shadow-sm)] transition-shadow duration-200 hover:shadow-[var(--shadow-md)]"
            >
              <img src={a.img} alt={`${a.name}, Ethiopia`} loading="lazy" decoding="async"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />
              <div className="absolute inset-0 bg-[linear-gradient(to_top,rgba(9,20,48,0.85)_0%,rgba(9,20,48,0.25)_55%,rgba(9,20,48,0.05)_100%)]" />
              <div className="absolute inset-x-0 bottom-0 p-4">
                <p className="flex items-center gap-1.5 text-base font-bold text-white">
                  <MapPin className="h-4 w-4 text-[#34D399]" /> {a.name}
                </p>
                <p className="mt-0.5 text-xs font-medium text-white/80" data-testid={`popular-area-tagline-${a.name.toLowerCase()}`}>
                  {a.tagline}
                </p>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};
